const useStartupUpdates = () => ({ updatesComplete: true, updateStatus: null });

export default useStartupUpdates;
